import { Box, styled } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { getConfigurePalette } from './configurePalette'
import { HOVER_CLASS } from './drawingSvgElements'

export const DrawingColumn = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.75),
  minWidth: 0,
  minHeight: 0,
  padding: theme.spacing(1),
  [theme.breakpoints.up('md')]: { paddingLeft: theme.spacing(1.5), paddingRight: theme.spacing(1.5) },
}))

type ViewportCursor = 'default' | 'grab' | 'grabbing'

export const DrawingViewport = styled(Box, { shouldForwardProp: prop => prop !== 'cursorMode' })<{
  cursorMode: ViewportCursor
}>(({ theme, cursorMode }) => ({
  position: 'relative',
  flex: '1 1 auto',
  minHeight: 420,
  overflow: 'auto',
  overscrollBehavior: 'contain',
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  borderRadius: 8,
  backgroundColor: getConfigurePalette(theme).canvas,
  userSelect: 'none',
  cursor: cursorMode,
  [theme.breakpoints.up('md')]: { minHeight: 0 },
  '& .cfg-halo': { transition: 'stroke-opacity .12s, fill-opacity .12s' },
  [`& .cfg-halo.${HOVER_CLASS}`]: { strokeOpacity: 0.3, fillOpacity: 0.3 },
  [`& rect.${HOVER_CLASS}`]: { strokeWidth: 2.6, filter: 'drop-shadow(0 1px 2px rgba(0,0,0,.25))' },
  ...(cursorMode !== 'default' && {
    '& [data-cfg-id], & svg': { cursor: `${cursorMode} !important` },
  }),
}))

export const SvgHost = styled(Box, { shouldForwardProp: prop => prop !== 'zoom' && prop !== 'visible' })<{
  zoom: number
  visible: boolean
}>(({ zoom, visible }) => {
  const zoomedSize = `${zoom * 100}%`
  return {
    display: visible ? 'block' : 'none',
    width: zoomedSize,
    height: zoomedSize,
    minWidth: zoomedSize,
    minHeight: zoomedSize,
    '& svg': { width: '100%', height: '100%', display: 'block' },
  }
})
